<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <!-- 商品模板 -->
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(cart, index) in cartInfo"
        :key="cart.id"

      >
        <div class="pictrue">
          <img v-lazy="cart.productInfo.image" alt="img" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <!-- <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div> -->
          <div class="Guige">{{ cart.productInfo.attrInfo && cart.productInfo.attrInfo.suk || "" }}</div>
          <div class="money font-color-red">
            {{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
          </div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>

<!-- 虚拟商品激活码 -->
      <ul v-if="cart.productInfo.is_product_virtual == 1" class="redeem-video-members" v-for="(item, ind) in cart.vip_card" :key="ind">
        <li class="activation-code">电子券兑换</li>
        <li class="code-text">{{item.title}}</li>
        <li class="code-text">券号：<span class="code-text-right">{{item.cradname}}</span></li>
        <li class="code-text">密码：<span class="code-text-right">{{item.camilo}}</span></li>
        <!-- <li class="code-text">有效期：<span class="code-text-right">2021-12-02</span></li> -->
        <li class="page-margin-top1" v-if="item.remarks">{{item.remarks}}</li>
      </ul>
        <div class="wrapper" v-if="orderInfo.delivery_type === 'express' && orderInfo.is_stores >= 2">

            <div class="items acea-row row-between">
              <div>配送方式：</div>
              <div class="conter" v-if="cart.delivery_name && cart.delivery_id">
                发货
              </div>
              <div class="conter" v-else>
                暂无
              </div>
            </div>
            <div class="items acea-row row-between" style="margin-top:0.1rem">
              <div>快递公司：</div>
              <div class="conter">{{ cart.delivery_name || "暂无" }}</div>
            </div>
            <div class="items acea-row row-between" style="margin-top:0.1rem">
              <div>快递号：</div>
              <div class="conter">{{ cart.delivery_id || "暂无" }}</div>
            </div>
          <!-- </div> -->

          <div class="bnt default" v-if="orderInfo.delivery_type === 'express'"
                    @click="
                      goToLogistics(orderInfo.order_id, cart.gys_name)
                    ">
                    查看物流
                  </div>

        </div>



      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: []
    },
    orderInfo:{
      type:Array,
      default:[]
    }
  },
  computed: {},
  watch: {},
  data: function() {
    return {
    };
  },
  created: function() {
    
  },
  mounted: function() {

  },
  methods: {
    goToLogistics (id, name) {
      if (!id || !name) return this.$dialog.error("暂无物流信息");
      this.$router.push({ path: '/order/logistics/' + id+','+name });
    },
    copyFn: function (id) {
      const clipboard = new ClipboardJS(id);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
        clipboard.destroy();
      });
    },
  }
};
</script>
<style >
.order-submission .wrapper .items{padding:0.27rem 0.3rem;font-size:0.3rem;color:#282828;border-bottom:1px solid #f0f0f0;}
.order-submission .wrapper .items .discount{font-size:0.3rem;color:#999;width: 5rem;text-align: right;}
.order-submission .wrapper .items .discount .integral{margin-right: 0.4rem;}
.order-submission .wrapper .items .discount .checkbox-wrapper .icon{right: 0;left: unset;}
.order-submission .wrapper .items .discount .iconfont{color:#515151;font-size:0.3rem;margin-left:0.15rem;}
.order-submission .wrapper .items .discount .num{font-size:0.32rem;margin-right:0.2rem;}
.order-submission .wrapper .items textarea{background-color:#f9f9f9;width:6.9rem;height:1.4rem;border-radius:0.03rem;
    margin-top:0.3rem;padding:0.25rem 0.28rem;}
.order-submission .wrapper .items textarea::placeholder{color:#ccc;}
.order-submission .wrapper .items .list{margin-top:0.35rem;}
.order-submission .wrapper .items .list .payItem{border:1px solid #eee;border-radius:0.06rem;height:0.86rem;width:100%;
    margin-top:0.2rem;font-size:0.28rem;color:#282828;}
.order-submission .wrapper .items .list .payItem.on{border-color:#fc5445;color:#e93323;}
.order-submission .wrapper .items .list .payItem .name{width:30%;text-align:center;border-right:1px solid #eee;}
.order-submission .wrapper .items .list .payItem .name .iconfont{width:0.44rem;height:0.44rem;border-radius:50%;
    text-align:center;line-height:0.44rem;background-color:#fe960f;color:#fff;font-size:0.3rem;margin-right:0.15rem;}
.order-submission .wrapper .items .list .payItem .name .iconfont.icon-weixin2{background-color:#41b035;}
.order-submission .wrapper .items .list .payItem .name .iconfont.icon-yinhangqia{background-color:#eb6623;}
.order-submission .wrapper .items .list .payItem .tip{width:70%;text-align:center;font-size:0.26rem;color:#aaa;}
.wrapper .items .conter{color:#868686;width:4.85rem;text-align:right;}
.wrapper .items .conter .copy{font-size:0.2rem;color:#333;border-radius:0.03rem;border:1px solid #666;
    padding:0.03rem 0.15rem;margin-left:0.24rem;}

  .bnt{
    width: 2rem;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
    border-radius: 0.5rem;
    /* color: #fff; */
    font-size: 0.27rem;
    padding: 0 3%;
    float:right;
    margin-top:0.2rem;
  }
  .bnt.default {
    color: #444;
    border: 1px solid #444
  }

.redeem-video-members{
  width:100%;
  min-height: 3.6rem;
  margin: .1rem auto .3rem;
  box-sizing: border-box;
  padding: .2rem;
  background: #f7f7f7;
  border-radius: .2rem;
}
.redeem-video-members:last-child{
  margin-bottom: 0;
}
.redeem-video-members .activation-code{
 height: .7rem;
 line-height: .7rem;
 border-bottom: .02rem solid #ccc;
 color: #868686;
 margin-bottom: .1rem;
}
.redeem-video-members .copy-btn {
  width: 2.6rem;
  height: .6rem;
  border: 0.02rem solid #f0c34c;
  border-radius: .4rem;
  text-align: center;
  line-height: .6rem;
}
.code-text {
  height: .6rem;
  line-height: .6rem;
  color:  #868686;
}
.code-text-right {
  margin-left: .9rem;
  color: black;
}
.Guige{
  font-size: 0.28rem;
    color: #868686;
    margin-top: 0.1rem;
}
</style>
